class PremiumLogoCarousel extends HTMLElement {
  connectedCallback() {
    this.ring = this.querySelector('.exposure-premium-logo-rail__ring');
    this.items = Array.from(
      this.ring?.querySelectorAll('.exposure-premium-logo-rail__item:not([data-marquee-clone])') || []
    );
    if (!this.ring || this.items.length === 0) return;

    this.marqueeClones = [];
    this.onResize = this.onResize.bind(this);
    this.onResize();
    window.addEventListener('resize', this.onResize, { passive: true });

    this.classList.add('is-ready');
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.onResize);
    this.teardownMarquee();
  }

  setupMarquee() {
    if (this.marqueeClones.length > 0) return;

    this.items.forEach((item) => {
      const clone = item.cloneNode(true);
      clone.setAttribute('data-marquee-clone', 'true');
      clone.setAttribute('aria-hidden', 'true');
      this.ring.appendChild(clone);
      this.marqueeClones.push(clone);
    });
  }

  teardownMarquee() {
    this.marqueeClones.forEach((clone) => clone.remove());
    this.marqueeClones = [];
  }

  applyMarqueeLayout(count, logoHeight) {
    this.classList.add('exposure-premium-logo-rail__carousel--marquee');
    this.setupMarquee();
    const duration = Math.max(32, count * 2.4);
    this.style.setProperty('--marquee-duration', `${duration.toFixed(1)}s`);
    this.style.setProperty('--scene-height', `${(logoHeight * 1.2).toFixed(2)}px`);
  }

  onResize() {
    const count = this.items.length;
    if (count === 0) return;

    const root = this.closest('.exposure-premium-logo-rail') || this;
    const styles = getComputedStyle(root);
    const logoHeight = parseFloat(styles.getPropertyValue('--logo-height')) || 85;

    this.applyMarqueeLayout(count, logoHeight);
  }
}

if (!customElements.get('premium-logo-carousel')) {
  customElements.define('premium-logo-carousel', PremiumLogoCarousel);
}
